import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthBllService } from '../../features/auth/auth-bll.service';
import { StorageService } from '../services/storage.service';

/**
 * HTTP interceptor that automatically adds the stored ID token to requests,
 * handles PKCE-exempt routes via a `Skip-Auth` header, and logs out on expired or unauthorized tokens.
 *
 * - If the `Skip-Auth` header is present, it is removed and the request proceeds without an Authorization header.
 * - Otherwise, if the token exists and is not yet expired, it is applied to the `Authorization` header.
 * - If the token is missing or expired, the user is logged out via AuthBllService before the request is sent.
 * - Catches 401/403 responses to allow optional logout or other side effects.
 *
 * @param req   The outgoing `HttpRequest` to intercept.
 * @param next  The next interceptor in the chain, or the backend handler.
 * @returns     An `Observable` of the HTTP event stream.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const authService = inject(AuthBllService);
  // Retrieve stored token and expiration timestamp
  const token = storage.getIdToken();
  
  const expiresAt = storage.getExpiresAt();
  const now = Math.floor(Date.now() / 1000);

  // If marked to skip auth, remove the marker header and proceed
  if (req.headers.has('Skip-Auth')) {
    const modifiedReq = req.clone({
      headers: req.headers.delete('Skip-Auth'), // Clean up the header
    });
    return next(modifiedReq);
  } else {
    // If token exists and is not yet expired, attach it
    // if (token && expiresAt && expiresAt > now) {
      const clonedRequest = token
        ? req.clone({ setHeaders: { Authorization: `${token}` } })
        : req;

      return next(clonedRequest).pipe(
        catchError((error) => {
          // On 401 or 403, optionally trigger logout or other handling
          if (error.status === 401 || error.status === 403) {
            console.log('User has logged out');
            //authService.logout();
          }

          return throwError(() => error);
        })
      );
    // } else {
    //   // Token missing or expired → force logout and proceed without auth header
    //   //authService.logout();
    //   return next(req);
    // }
  }
};
